import { render, staticRenderFns } from "./spirit-bottle-4.vue?vue&type=template&id=ece69ebe"
import script from "./spirit-bottle-4.vue?vue&type=script&lang=js"
export * from "./spirit-bottle-4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports